export default __webpack_public_path__ + "static/media/call.9b34f121.svg";